var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1873 4.13678C21.5244 3.17673 19.4756 3.17675 17.8127 4.13678L7.67258 9.99124C6.00972 10.9513 4.98535 12.7255 4.98535 14.6456V26.3545C4.98535 28.2747 6.00972 30.0488 7.67258 31.0089L17.8127 36.8634C19.4756 37.8234 21.5244 37.8234 23.1873 36.8634L33.3274 31.0089C34.9903 30.0488 36.0146 28.2747 36.0146 26.3545V14.6456C36.0146 12.7255 34.9903 10.9513 33.3274 9.99124L23.1873 4.13678ZM24.8228 14.5727C25.323 14.0724 25.323 13.2611 24.8228 12.7608C24.3225 12.2604 23.5112 12.2604 23.0108 12.7608L16.1775 19.5942C15.811 19.9606 15.7014 20.5117 15.8997 20.9904C16.098 21.4692 16.5652 21.7813 17.0834 21.7813H20.8236L16.1775 26.4275C15.6771 26.9279 15.6771 27.739 16.1775 28.2393C16.6778 28.7397 17.4891 28.7397 17.9895 28.2393L24.8228 21.406C25.1893 21.0396 25.2988 20.4885 25.1004 20.0098C24.9021 19.5309 24.4351 19.2188 23.9167 19.2188H20.1767L24.8228 14.5727Z",
    fill: "url(#paint0_linear_78_237)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_237",
    x1: 20.5,
    y1: 3.41675,
    x2: 20.5,
    y2: 37.5834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8280FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerLogo);
export default __webpack_public_path__ + "static/media/Power Logo.7f689a26debfc3deadbb5eac600f757d.svg";
export { ForwardRef as ReactComponent };